import angular from 'angular';

import tooltipComponent from './tooltip-component';

const tooltip = angular.module('tooltip', []);
tooltip.component('tooltip', tooltipComponent);

export default tooltip.name;
